import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  // base: "yiban_app_web",//正式上线需去掉
  routes: [
    {
      path: '/writings-list',
      name: '文章列表',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/writings-list')
    },
    {
      path: '/writings-details',
      name: '文章详情',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/writings-details')
    },
    {
      path: '/caution-money',
      name: '认证保证金',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/caution-money')
    },
    {
      path: '/caution-money-v1',
      name: '认证保证金(重构)',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/caution-money-v1')
    },
    {
      path: '/alipay-info',
      name: '保证金提现申请',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/alipay-info')
    },
    {
      path: '/alipay-info-v1',
      name: '保证金提现申请(重构)',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/alipay-info-v1')
    },
    {
      path: '/invitation-reward',
      name: '邀请有奖',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/invitation-reward')
    },
    {
      path: '/invitation-reward-v1',
      name: '邀请有奖(重构)',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/invitation-reward-v1')
    },
    {
      path: '/invitation-course',
      name: '邀请教程',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/invitation-course')
    },
    {
      path: '/invitation-course-v1',
      name: '邀请教程(重构)',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/invitation-course-v1')
    },
    {
      path: '/invitation-process',
      name: '邀请教程(only)',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/invitation-process')
    },
    {
      path: '/blind-date',
      name: '相亲大会',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/blind-date')
    },
    {
      path: '/enroll-info',
      name: '填写报名信息',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/enroll-info')
    },
    {
      path: '/public-num',
      name: '引导关注公众号',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/public-num')
    },
    {
      path: '/love-consultant',
      name: '引导关注爱情顾问',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/love-consultant')
    },
    {
      path: '/love-consultant-reward',
      name: '爱情顾问关注奖励',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/love-consultant-reward')
    },
    {
      path: '/task',
      name: '任务中心',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/task')
    },
    {
      path: '/question',
      name: '问题集',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/question')
    },
    {
      path: '/successful-case',
      name: '成功案例',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/successful-case')
    },
    {
      path: '/case-details',
      name: '案例详情',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/case-details')
    },
    {
      path: '/case-details-share',
      name: '案例详情分享页面',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/case-details-share')
    },
    {
      path: '/comment',
      name: '留言',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/comment')
    },
    {
      path: '/artificial-remove-single',
      name: '人工脱单服务',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/artificial-remove-single')
    },
    {
      path: '/invite-prizes',
      name: '邀请有奖(新)',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/invite-prizes')
    },
    {
      path: '/auth-fee-apply-return',
      name: '认证费申请返还',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/auth-fee-apply-return')
    },
    {
      path: '/chat-honey-degree',
      name: '聊天蜜度规则',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/chat-honey-degree')
    },
    {
      path: '/get-invitecode-tutorial',
      name: '如何获取邀请码',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/get-invitecode-tutorial')
    },
    {
      path: '/get-invitecode-tutorial-new',
      name: '如何获取邀请码',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/get-invitecode-tutorial-new')
    },
    {
      path: '/public-num-notes',
      name: '引导关注公众号',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/public-num-notes')
    },
    {
      path: '/public-num-notes-v1',
      name: '引导关注公众号v1',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/public-num-notes-v1')
    },
    {
      path: '/coffee-exchange',
      name: '兑换咖啡/奶茶',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/coffee-exchange')
    },
    {
      path: '/violation-list',
      name: '违规通报',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/violation-list')
    },
    {
      path: '/contact-matchmaker',
      name: '联系专属红娘',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/contact-matchmaker')
    },
    {
      path: '/talent-cash-out',
      name: '达人提现',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/talent-cash-out')
    },
    {
      path: '/talent-cash-out-wx',
      name: '达人提现(公众号)',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/talent-cash-out-wx')
    },
    {
      path: '/share-voucher',
      name: '分享领代金券',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/share-voucher')
    },
    {
      path: '/recommend-set',
      name: '个性推荐设置',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/recommend-set')
    },
    {
      path: '/queqiaohui-index',
      name: '慈海鹊桥会',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/queqiaohui-index')
    },
    {
      path: '/queqiaohui-info',
      name: '填写包名信息',
      component: () => import(/* webpackChunkName: "group-foo" */ '@/views/queqiaohui-info')
    },
    //因为需要微信授权，迁移到yiban_imitate_app
    // {
    //   path: '/wechat-binding',
    //   name: '绑定登录手机号',
    //   component: () => import(/* webpackChunkName: "group-foo" */ '@/views/wechat-binding')
    // },
    // {
    //   path: '/wechat-binding-success',
    //   name: '绑定成功',
    //   component: () => import(/* webpackChunkName: "group-foo" */ '@/views/wechat-binding-success')
    // },
    // {
    //   path: '/public-num-reward',
    //   name: '公众号关注奖励',
    //   component: () => import(/* webpackChunkName: "group-foo" */ '@/views/public-num-reward')
    // },
  ]
})

router.afterEach((to, from) => {
  const u = navigator.userAgent.toLowerCase()
  if(u.indexOf("like mac os x") < 0 || u.match(/MicroMessenger/i) != 'micromessenger') return
  if (to.path !== global.location.pathname) {
    location.assign(to.fullPath)
  }
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js